<form>
  <div class="line">
    <h3 class="title">{{ 'chainmemory.parameters.picturesConfig' | translate }}</h3>
  </div>
  <div class="line">
    <ms-form-field appearance="flat" color="purple">
      <ms-label>{{ 'textsFilter.difficulty' | translate }}</ms-label>
      <ms-select gameParameter="filterPDifficulty">
        <ms-option *ngFor="let i of [].constructor(11); index as index" [value]="index.toString()">
          <span>{{ index === 0 ? ('textsFilter.any' | translate) : index }}</span>
        </ms-option>
      </ms-select>
    </ms-form-field>

    <ms-form-field appearance="flat" color="purple">
      <ms-label>{{ 'textsFilter.langs.label' | translate }}</ms-label>
      <ms-select gameParameter="filterPLang">
        <ms-option *ngFor="let lang of langs" [value]="lang.value">
          {{ lang.title | translate }}
        </ms-option>
      </ms-select>
    </ms-form-field>
  </div>

  <div class="line">
    <ms-form-field appearance="flat" color="purple">
      <ms-label>{{ 'resource.lead.source' | translate }}</ms-label>
      <ms-select gameParameter="filterPOwn">
        <ms-option
          *ngFor="let vari of filterVars"
          [value]="vari"
          [hidden]="vari === 'my_center' && !isAccessAccountType"
        >
          {{ 'textsFilter.vars.' + vari | translate }}
        </ms-option>
      </ms-select>
    </ms-form-field>

    <ms-form-field appearance="flat" color="purple">
      <ms-label>{{ 'materials.age' | translate }}</ms-label>
      <ms-select gameParameter="filterPAge">
        <ms-option *ngFor="let i of [].constructor(16); index as index" [value]="index.toString()">
          <span>{{ index === 0 ? ('textsFilter.any' | translate) : index }}</span>
        </ms-option>
      </ms-select>
    </ms-form-field>
  </div>

  <div class="line" *ngIf="!isLoading; else loadingGif">
    <div class="form-field select-output">
      <ms-multiselect-with-search
        [placeholder]="placeholderTranslationKeyForSelectComponent | translate"
        [items]="itemsForSelectComponent"
        [selectedValues]="selectedIds"
        (change)="updateSelectedIds($event)"
      />
      <mat-error *ngIf="isDataEmpty" class="methodic-materials-warning">
        {{'picturesFilter.error.dataIsEmpty' | translate }}
      </mat-error>
    </div>
  </div>
</form>

<ng-template #loadingGif>
  <mat-spinner diameter="40"></mat-spinner>
</ng-template>
